import RoutesComponent from "./router/routes";

function App() {
  return (
    <div className="App">
      <RoutesComponent></RoutesComponent>
    </div>
  );
}
export default App;
